const ProductDetailAttributes = {
    options: {
        data: {},
        customization: {},
        widgets: {
            Menu_ProductAttributes: {
                type: 'Menu',
                order: 900,
                renderOptions: {
                    controlKey: 'productAttributes',
                },
                options: {
                    disabledAttributes: {
                        type: 'Modal',
                        data: {
                            type: "ProductAttribute"
                        },
                    },

                },
            },
        },
    },
    variants: [
        {
            id: 'ProductDetailAttributes_1',
            name: 'ProductDetailAttributes_1',
            type: 'ProductDetailAttributes',
            data: {
                text: '',
            },
            customization: {
                disabledAttributes: []
            },
            variantData: {
                isEditable: false,
                aspectRatio: '1/1',
                minImage: 4,
                maxImage: 12,
                modulo: 1,
                renderTabs: {
                    product: null,
                },
            },
            placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/ProductDetailAttributes_1.png',
            minMobileAppVersion: 1,
            isComingSoon: false,
        }
    ],
};

export default ProductDetailAttributes;
